import { Flex } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const FlightCurveContainer = styled(Flex).attrs({ gap: 24, flex: 1 })`
  margin-top: 24px;
  border-radius: 8px;
  border: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
  background-color: ${COLOR_OPTIONS.NEUTRAL_00};

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    margin-top: 0;
    border: none;
    border-radius: 0;
  }
`;
